<template>
    <div>
        <Modal v-model="show"
            :width="70"
            :footer-hide="true"
            title="入库记录"
            class-name="vertical-center-modal"
            @on-visible-change="onShowChange">
            <Card :padding="0"
                :bordered="false"
                :dis-hover="true">
                <Row :gutter="16">
                    <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">备用库入库单列表</span>
                        </div>
                        <div class="right-bar">
                            <Button v-if="$checkAccessArray(['B', 'C'])"
                                size='small'
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreateWarehouseForwardEntry">新增</Button>
                        </div>
                    </div>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="24">
                    <stand-pagination-table :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getWarehouseForwardEntryTableRecord" />
                    </Col>
                </Row>
            </Card>
        </Modal>
        <!-- <Modal v-model="transModal.show"
            :styles="{top: '10px'}"
            title="转入库"
            width="70">
            <Row :gutter="16">
                <Col span="24">
                <Table
                    :columns="transModal.table.columns"
                    :data="transModal.table.rows"
                    :border="true"
                    :stripe="true"/>
                </Col>
            </Row>

            <div slot="footer">
                <Button type="primary"
                    @click="onSubmitTrans">提交</Button>
            </div>
        </Modal> -->
        <WarehouseForwardEntryEdit ref="warehouseForwardEntryEditModal" />
        <WarehouseForwardEntryDetail ref="warehouseForwardEntryDetailModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateRender } from '@/libs/tableRowTimeRender';
import IntegerInput from '@/components/number-input/integer-input';
import { TRANS_STATUS_TYPE_NO } from '@/view/preSale-management/preSale-warehouse-forward-entry/PreSaleWarehouseForwardStatus';
import {
    getWarehouseForwardEntryDetail,
    getWarehouseForwardEntryList,
    submitWarehouseForwardEntryTrans
} from '@/api/modules/warehouse-management/warehouseEntry';

import WarehouseForwardEntryEdit from '../preSale-warehouse-forward-entry/preSale-warehouse-forward-entry-edit';
import WarehouseForwardEntryDetail from '../preSale-warehouse-forward-entry/preSale-warehouse-forward-entry-detail';

export default {
    name: 'WarehouseForwardEntryList',
    components: {
        SearchCard,
        StandPaginationTable,
        IntegerInput,
        WarehouseForwardEntryEdit,
        WarehouseForwardEntryDetail
    },
    data() {
        return {
            show: false,
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '单号', key: 'warehouseForwardEntryRecordBillCode', align: 'center' },
                    { title: '批次', key: 'warehouseForwardEntryRecordBatchCode', align: 'center' },
                    { title: '苗场', key: 'seedFarmName', align: 'center' },
                    { title: '项目', key: 'warehouseForwardEntryRecordProject', align: 'center' },
                    { title: '制单人', key: 'userPersonName', align: 'center' },
                    { title: '转入库状态', key: 'warehouseForwardEntryRecordTransStatus', align: 'center' },
                    { title: '入库日期', key: 'warehouseForwardEntryRecordCreateAt', align: 'center', render: (h, params) => dateRender(h, params.row.warehouseForwardEntryRecordCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            const btns = [];

                            const viewBtnElement = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small',
                                    shape: 'circle'
                                },
                                style: {
                                },
                                on: {
                                    click: () => {
                                        this.$refs.warehouseForwardEntryDetailModal.showModal(params.row.warehouseForwardEntryRecordUuid);
                                        // this.$router.push({
                                        //     name: 'preSale-warehouse-forward-entry-detail',
                                        //     query: {
                                        //         warehouseForwardEntryRecordUuid: params.row.warehouseForwardEntryRecordUuid
                                        //     }
                                        // });
                                    }
                                }
                            }, '查看');
                            btns.push(viewBtnElement);

                            // if (params.row.warehouseForwardEntryRecordTransStatus === TRANS_STATUS_TYPE_NO) {
                            //     const transBtnElement = h('Button', {
                            //         props: {
                            //             type: 'text',
                            //             size: 'small',
                            //             shape: 'circle'
                            //         },
                            //         style: {
                            //         },
                            //         on: {
                            //             click: () => {
                            //                 this.onShowTransModal(params.row);
                            //             }
                            //         }
                            //     }, '转入库');
                            //     btns.push(transBtnElement);
                            // }

                            return h('div', btns);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '登陆帐号', type: 'Input', value: '', name: 'userName', sql: 'like' },
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            transModal: {
                show: false,
                warehouseForwardEntryRecordUuid: '',
                table: {
                    columns: [
                        { title: '产品编号', key: 'warehouseForwardEntryDetailProductCode', align: 'left' },
                        { title: '名称', key: 'warehouseForwardEntryDetailProductName', align: 'left' },
                        { title: '预入库数量', key: 'warehouseForwardEntryDetailAmount', align: 'right' },
                        {
                            title: '实际入库量',
                            key: 'action',
                            align: 'right',
                            fixed: 'right',
                            render: (h, params) => {
                                return h(IntegerInput, {
                                    props: {
                                        min: 0,
                                        max: 100000000,
                                        value: params.row.warehouseForwardEntryDetailAmount
                                    },
                                    style: {
                                    },
                                    on: {
                                        change: val => {
                                            this.transModal.table.rows[params.index].warehouseForwardEntryDetailTransAmount = val;
                                        }
                                    }
                                });
                            }
                        }
                    ],
                    rows: []
                }
            }
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal() {
            this.show = true;
        },
        init() {
            this.getWarehouseForwardEntryTableRecord();
        },
        getWarehouseForwardEntryTableRecord(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }

            getWarehouseForwardEntryList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        },
        onCreateWarehouseForwardEntry() {
            this.$refs.warehouseForwardEntryEditModal.showModal();
            // this.$router.push({ name: 'preSale-warehouse-forward-entry-edit' });
        },
        onShowTransModal(row) {
            this.transModal.warehouseForwardEntryRecordUuid = row.warehouseForwardEntryRecordUuid;
            getWarehouseForwardEntryDetail(this.transModal.warehouseForwardEntryRecordUuid).then(res => {
                if (res.code === 0) {
                    this.transModal.table.rows = res.data.details;
                    this.transModal.show = true;
                }
            });
        },
        onSubmitTrans() {
            const submitData = {
                warehouseForwardEntryRecordUuid: this.transModal.warehouseForwardEntryRecordUuid,
                transProducts: this.transModal.table.rows.map(item => {
                    return {
                        warehouseForwardEntryDetailUuid: item.warehouseForwardEntryDetailUuid,
                        warehouseForwardEntryDetailTransAmount: item.warehouseForwardEntryDetailTransAmount
                    };
                })
            };

            this.$Spin.show();
            submitWarehouseForwardEntryTrans(submitData).then(res => {
                this.$Spin.hide();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '转入库成功',
                        onOk: () => {
                            this.transModal.show = false;
                            this.init();
                        }
                    });
                }
            }).catch(() => {
                this.$Spin.hide();
            });
        }
    }
};
</script>

<style scoped>
</style>
